export const networkTypes = [
    { value: "BTC", label: "BTC" },
    { value: "ETH", label: "ETH" },
    { value: "BNB", label: "BNB" },
    { value: "TRX", label: "TRX" },
    { value: "POL (MATIC)", label: "POL (MATIC)" },
    { value: "LTC", label: "LTC" },
    { value: "SOL", label: "SOL" },
    { value: "XRP", label: "XRP" },
];